import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  getOrganizationApplicationTemplate,
  OrganizationApplicationTemplate,
  updateOrganizationApplicationTemplate,
} from '~/javascripts/admin/actions/merchant-application-templates';
import Headings from '../../atoms/Headings';
import BreadCrumb from '../../molecules/BreadCrumb';
import EditMerchantApplicationTemplate, {
  MerchantApplicationTemplateValues,
} from '../EditMerchantApplicationTemplate';

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: '決済加盟店管理', href: '', isCurrentPage: true },
  { value: '加盟店申込フォーム', href: '/organizations/application-form', isCurrentPage: false },
  { value: '加盟店申込フォーム詳細', href: '', isCurrentPage: true },
];

const MerchantApplicationTemplateDetails = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [template, setTemplate] = useState<OrganizationApplicationTemplate | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getOrganizationApplicationTemplate(id)
      .then((res) => {
        setTemplate(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const onConfirm = async (formValues: MerchantApplicationTemplateValues) => {
    const params = {
      title: formValues.title,
      status: formValues.status,
      application_term_url: formValues.application_term_url || null,
      redirect_url: formValues.redirect_url || null,
      private_money_ids: formValues.private_money_ids,
      capital_field_option: formValues.capital_field_option,
      number_of_employees_field_option: formValues.number_of_employees_field_option,
      referral_source_field_option: formValues.referral_source_field_option,
      description: formValues.description,
      user_tag_group_options: formValues.user_tag_group_options,
    };

    await updateOrganizationApplicationTemplate(id, params);
    history.push('/organizations/application-form');
  };

  if (loading) {
    return (
      <>
        <BreadCrumb crumbs={CRUMBS} />
        <div>読み込み中...</div>
      </>
    );
  }

  if (!template) {
    return (
      <>
        <BreadCrumb crumbs={CRUMBS} />
        <div>データが見つかりませんでした</div>
      </>
    );
  }

  const formValues: MerchantApplicationTemplateValues = {
    id: template.id,
    title: template.title,
    status: template.status,
    application_term_url: template.application_term_url ?? '',
    redirect_url: template.redirect_url ?? '',
    private_money_ids: template.private_money_ids,
    capital_field_option: template.capital_field_option,
    number_of_employees_field_option: template.number_of_employees_field_option,
    referral_source_field_option: template.referral_source_field_option,
    description: template.description,
    issuer_organization_code: template.issuer_organization_code,
    user_tag_group_options: template.user_tag_group_options,
  };

  return (
    <>
      <BreadCrumb crumbs={CRUMBS} />
      <Headings.h5>加盟店申込フォーム詳細</Headings.h5>
      <EditMerchantApplicationTemplate
        mode="edit"
        formValues={formValues}
        templateId={template.id}
        onConfirm={onConfirm}
      />
    </>
  );
};

export default MerchantApplicationTemplateDetails;
